import _ from 'lodash'
import createModel from 'utils/model'
import {getList, create, edit, remove} from 'message-control/services/session-tag'

export default createModel({
    namespace: 'messageControl_sessionTag',

    state: {
        tableList: {},
    },

    effects: {
        *getList(xx, {select, put, call}) {
            const {tableList} = yield select(
                ({messageControl_sessionTag}) => messageControl_sessionTag,
            )

            const newParams = {
                offset: tableList.pagination.pageSize * (tableList.pagination.current - 1),
                limit: tableList.pagination.pageSize,
                ...tableList.params,
            }

            const res = yield call(getList, newParams)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableList.dataSource = res.data
                    draft.tableList.pagination.total = _.get(res, 'pagination.rows_found', 0)
                },
            })
        },

        *create({payload}, {call}) {
            return yield call(create, payload)
        },

        *edit({payload}, {call}) {
            return yield call(edit, payload)
        },

        *remove({payload}, {call}) {
            return yield call(remove, payload)
        },
    },
})
